import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const ContactsFirstNameWUT = (props)=>{
    const fieldType = FIELD_TYPES.CONTACTS_FIRST_NAME;
    return /*#__PURE__*/ React.createElement(TextInputFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=contacts-first-name-wut.js.map